import SectionHeading from '@/pages/home/components/SectionHeading';
import { appNotes } from '@/mocks/cinemaData';

export default function AppSection() {
  return (
    <section id="app" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="APP 下载"
          title="关于秋霞影院 APP 下载，先弄清这几件事"
          desc="本页不提供任何下载链接或安装包，只整理下载前后需要判断的通用事项。这些要点适合任何影音类客户端，可帮你少踩坑。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {appNotes.map((note) => (
            <article
              key={note.title}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                <i className={`${note.icon} text-lg`} aria-hidden="true" />
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{note.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{note.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-8 rounded-lg border border-primary-300 bg-primary-100/70 p-5">
          <div className="flex items-start gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-error-warning-line text-lg" aria-hidden="true" />
            </span>
            <div>
              <h3 className="font-heading text-base font-semibold text-foreground-950">不装 APP 也能用，先试网页再决定</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                如果你只是想临时看看，没必要一上来就安装客户端。先用浏览器打开网页版或手机版确认能正常访问、内容也符合预期，再决定是否需要安装。这样既能省下设备空间，也能避免安装来源不明的安装包。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}